import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Twitter, Instagram, Facebook, Linkedin, Github } from "lucide-react";
import Logo from "./Logo";
import { cn } from "@/lib/utils";
import CookiePreferences from "@/components/CookiePreferences";

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  const [isCookiePreferencesOpen, setIsCookiePreferencesOpen] = useState(false);
  const currentYear = new Date().getFullYear();

  const openCookiePreferences = () => {
    setIsCookiePreferencesOpen(true);
  };

  return (
    <footer
      className={cn(
        "w-full bg-gradient-to-b from-blue-700 via-blue-800 to-gray-900 text-white py-10 px-6",
        className
      )}
    >
      <div className="max-w-7xl mx-auto">
        {/* Footer content container */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* Logo and copyright section */}
          <div className="col-span-1">
            <Logo className="text-white mb-4" />
            <p className="text-sm">Copyright © {currentYear}</p>
            <p className="text-sm mt-1">𝘿𝙚𝙨𝙞𝙜𝙣𝙚𝙙 𝙗𝙮 𝙇𝙞𝙛𝙚 𝙘𝙤𝙣𝙘𝙚𝙥𝙩.</p>
          </div>

          <div className="col-span-1">
            <h3 className="text-xl font-bold mb-4">Liens rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-leo-blue transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="hover:text-leo-blue transition-colors"
                >
                  À propos
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="hover:text-leo-blue transition-colors"
                >
                  Evenements
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-1">
            <h3 className="text-xl font-bold mb-4">Liens utiles</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/projects"
                  className="hover:text-leo-blue transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/skills"
                  className="hover:text-leo-blue transition-colors"
                >
                  Compétences
                </Link>
              </li>
              <li>
                <Link
                  to="/resume"
                  className="hover:text-leo-blue transition-colors"
                >
                  Parcours
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-1">
            <h3 className="text-xl font-bold mb-4">Légal</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/terms"
                  className="hover:text-leo-blue transition-colors"
                >
                  Conditions d'utilisation
                </Link>
              </li>
              <li>
                <Link
                  to="/security"
                  className="hover:text-leo-blue transition-colors"
                >
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <button
                  onClick={openCookiePreferences}
                  className="hover:text-leo-blue transition-colors"
                >
                  Préférences de cookies
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Separator */}
        <div className="h-px bg-white bg-opacity-20 my-6"></div>

        {/* Bottom section */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <Link
              to="/contact"
              className="py-2 px-6 text-white rounded-md font-semibold transition-colors hover:bg-opacity-90"
            >
              ME CONTACTER
            </Link>
          </div>
          <div className="flex space-x-4">
            <a
              href="https://instagram.com/mopaossi"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <Instagram
                size={20}
                className="hover:text-leo-blue transition-colors"
              />
            </a>

            <a
              href="https://linkedin.com/in/ben-mombouli"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <Linkedin
                size={20}
                className="hover:text-leo-blue transition-colors"
              />
            </a>
            <a
              href="https://github.com/hackerGit29"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Github"
            >
              <Github
                size={20}
                className="hover:text-leo-blue transition-colors"
              />
            </a>
          </div>
        </div>
      </div>
      <CookiePreferences 
        isOpen={isCookiePreferencesOpen} 
        onClose={() => setIsCookiePreferencesOpen(false)}
      />
    </footer>
  );
};

export default Footer;

